// Establishments
export const ESTABLISHMENT = '/establishment';
export const GET_ESTABLISHMENTS = '/establishment/';
export const GET_ESTABLISHMENTS_QUERY = '/establishment/query';
export const DELETE_ESTABLISHMENT = '/establishment';
export const ADD_ESTABLISHMENT = '/establishment/';
export const UPDATE_ESTABLISHMENT = '/establishment';
export const GET_ESTABLISHMENT_PRODUCTIVE_CYCLE_ACTIVE =
	'/establishment/productive_cycle/active';

// Communes
export const COMMUNE = '/commune';
export const GET_COMMUNES = '/commune/';
export const DELETE_COMMUNE = '/commune';
export const ADD_COMMUNE = '/commune/';
export const UPDATE_COMMUNE = '/commune';

// Regions
export const REGION = '/region';
export const GET_REGIONS = '/region/';
export const DELETE_REGION = '/region';
export const ADD_REGION = '/region/';
export const UPDATE_REGION = '/region';

// Sanitary vicinitys
export const SANITARY_VICINITY = '/sanitary_vicinity';
export const GET_SANITARY_VICINITIES = '/sanitary_vicinity/';
export const DELETE_SANITARY_VICINITY = '/sanitary_vicinity';
export const ADD_SANITARY_VICINITY = '/sanitary_vicinity/';
export const UPDATE_SANITARY_VICINITY = '/sanitary_vicinity';

// Productive areas
export const PRODUCTIVE_AREA = '/productive_area';
export const GET_PRODUCTIVE_AREAS = '/productive_area/';
export const DELETE_PRODUCTIVE_AREA = '/productive_area';
export const ADD_PRODUCTIVE_AREA = '/productive_area/';
export const UPDATE_PRODUCTIVE_AREA = '/productive_area';

// Establishment types
export const ESTABLISHMENT_TYPE = '/establishment_type';
export const GET_ESTABLISHMENT_TYPES = '/establishment_type/';
export const DELETE_ESTABLISHMENT_TYPE = '/establishment_type';
export const ADD_ESTABLISHMENT_TYPE = '/establishment_type/';
export const UPDATE_ESTABLISHMENT_TYPE = '/establishment_type';
export const ESTABLISHMENT_TYPE_CODES = '/establishment_type/codes';

// Company
export const COMPANY = '/company';
export const GET_COMPANIES = '/company/';
export const GET_COMPANY_WITH_HOUR_METER_LIST =
	'/fuel_supply/companies-with-hour-meter';
export const DELETE_COMPANY = '/company';
export const ADD_COMPANY = '/company/';
export const UPDATE_COMPANY = '/company';

// Cost Center
export const COST_CENTER = '/cost_center';
export const GET_COST_CENTER = '/cost_center/';
export const GET_COST_CENTER_QUERY = '/cost_center/query';
export const DELETE_COST_CENTER = '/cost_center';
export const ADD_COST_CENTER = '/cost_center/';
export const UPDATE_COST_CENTER = '/cost_center';
export const IMPORT_COST_CENTER = '/cost_center/import';

// Holding
export const HOLDING = '/holding_company';
export const GET_HOLDINGS = '/holding_company/';
export const DELETE_HOLDING = '/holding_company';
export const ADD_HOLDING = '/holding_company/';
export const UPDATE_HOLDING = '/holding_company';

// MaintenanceCompany
export const MAINTENANCE_COMPANY = '/maintenance_company';
export const GET_MAINTENANCE_COMPANY = '/maintenance_company/';
export const DELETE_MAINTENANCE_COMPANY = '/maintenance_company';
export const ADD_MAINTENANCE_COMPANY = '/maintenance_company/';
export const UPDATE_MAINTENANCE_COMPANY = '/maintenance_company';

// Management
export const MANAGEMENT = '/management';
export const GET_MANAGEMENTS = '/management/';
export const DELETE_MANAGEMENT = '/management';
export const ADD_MANAGEMENT = '/management/';
export const UPDATE_MANAGEMENT = '/management';
export const ORGANIZATIONAL_CHART_MANAGEMENT =
	'/management/organizational_chart/';

// Management Team
export const MANAGEMENT_TEAM = '/management/team';
export const GET_MANAGEMENT_TEAMS = '/management/team/';
export const DELETE_MANAGEMENT_TEAM = '/management/team';
export const ADD_MANAGEMENT_TEAM = '/management/team/';
export const UPDATE_MANAGEMENT_TEAM = '/management/team';

// Management Position
export const MANAGEMENT_POSITION = '/management/position';
export const GET_MANAGEMENT_POSITION = '/management/position/';
export const DELETE_MANAGEMENT_POSITION = '/management/position';
export const ADD_MANAGEMENT_POSITION = '/management/position/';
export const UPDATE_MANAGEMENT_POSITION = '/management/position';

// // Warehouse
// export const WAREHOUSE = '/warehouse';
// export const GET_WAREHOUSES = '/warehouse/';
// export const DELETE_WAREHOUSE = '/warehouse';
// export const ADD_WAREHOUSE = '/warehouse/';
// export const UPDATE_WAREHOUSE = '/warehouse';

// // Warehouse Item
// export const WAREHOUSE_ITEM = '/warehouse/item';
// export const GET_WAREHOUSE_ITEMS = '/warehouse/item/';
// export const DELETE_WAREHOUSE_ITEM = '/warehouse/item';
// export const ADD_WAREHOUSE_ITEM = '/warehouse/item/';
// export const UPDATE_WAREHOUSE_ITEM = '/warehouse/item';
// export const CHECK_WAREHOUSE_ITEM_EXISTS = '/warehouse/item/exists/';

// // Warehouse Category
// export const WAREHOUSE_CATEGORY = '/warehouse/category';
// export const GET_WAREHOUSE_CATEGORIES = '/warehouse/category/';
// export const DELETE_WAREHOUSE_CATEGORY = '/warehouse/category';
// export const ADD_WAREHOUSE_CATEGORY = '/warehouse/category/';
// export const UPDATE_WAREHOUSE_CATEGORY = '/warehouse/category';
// export const CHECK_WAREHOUSE_CATEGORY_EXISTS = '/warehouse/category/exists/';

// Productive Cycle
export const PRODUCTIVE_CYCLE = '/productive_cycle';
export const GET_PRODUCTIVE_CYCLE_QUERY = '/productive_cycle/query';
export const GET_PRODUCTIVE_CYCLE = '/productive_cycle/';
export const DELETE_PRODUCTIVE_CYCLE = '/productive_cycle';
export const ADD_PRODUCTIVE_CYCLE = '/productive_cycle/';
export const UPDATE_PRODUCTIVE_CYCLE = '/productive_cycle';

// Productive Cycle Status
export const PRODUCTIVE_CYCLE_STATUS = '/productive_cycle_status';
export const GET_PRODUCTIVE_CYCLE_STATUS = '/productive_cycle_status/';
export const DELETE_PRODUCTIVE_CYCLE_STATUS = '/productive_cycle_status';
export const ADD_PRODUCTIVE_CYCLE_STATUS = '/productive_cycle_status/';
export const UPDATE_PRODUCTIVE_CYCLE_STATUS = '/productive_cycle_status';

// Productive Cycle Stage
export const PRODUCTIVE_CYCLE_STAGE = '/productive_cycle_stage';
export const GET_PRODUCTIVE_CYCLE_STAGE = '/productive_cycle_stage/';
export const DELETE_PRODUCTIVE_CYCLE_STAGE = '/productive_cycle_stage';
export const ADD_PRODUCTIVE_CYCLE_STAGE = '/productive_cycle_stage/';
export const UPDATE_PRODUCTIVE_CYCLE_STAGE = '/productive_cycle_stage';

// Productive Cycle Stage Template
export const PRODUCTIVE_CYCLE_STAGE_TEMPLATE =
	'/productive_cycle_stage_template';
export const GET_PRODUCTIVE_CYCLE_STAGE_TEMPLATE =
	'/productive_cycle_stage_template/';
export const DELETE_PRODUCTIVE_CYCLE_STAGE_TEMPLATE =
	'/productive_cycle_stage_template';
export const ADD_PRODUCTIVE_CYCLE_STAGE_TEMPLATE =
	'/productive_cycle_stage_template/';
export const UPDATE_PRODUCTIVE_CYCLE_STAGE_TEMPLATE =
	'/productive_cycle_stage_template';
export const EXISTS_PRODUCTIVE_CYCLE_STAGE_TEMPLATE =
	'/productive_cycle_stage_template/exists';

// Species
export const SPECIES = '/species';
export const GET_SPECIES = '/species/';
export const DELETE_SPECIES = '/species';
export const ADD_SPECIES = '/species/';
export const UPDATE_SPECIES = '/species';

// Feeding Barges
export const FEEDING_BARGES = '/feeding_barges/';
export const GET_FEEDING_BARGES = '/feeding_barges';
export const DELETE_FEEDING_BARGES = '/feeding_barges';
export const ADD_FEEDING_BARGES = '/feeding_barges/';
export const UPDATE_FEEDING_BARGES = '/feeding_barges';

// Feeding Barges Type
export const FEEDING_BARGES_TYPE = '/feeding_barges_type/';
export const GET_FEEDING_BARGES_TYPE = '/feeding_barges_type/';
export const DELETE_FEEDING_BARGES_TYPE = '/feeding_barges_type';
export const ADD_FEEDING_BARGES_TYPE = '/feeding_barges_type/';
export const UPDATE_FEEDING_BARGES_TYPE = '/feeding_barges_type';

// Crop Type
export const CROP_TYPE = '/crop_type/';
export const GET_CROP_TYPE = '/crop_type/';
export const DELETE_CROP_TYPE = '/crop_type';
export const ADD_CROP_TYPE = '/crop_type/';
export const UPDATE_CROP_TYPE = '/crop_type';

// Fuel Type
export const FUEL_TYPE = '/fuel_type/';
export const GET_FUEL_TYPES = '/fuel_type/';
export const DELETE_FUEL_TYPE = '/fuel_type';
export const ADD_FUEL_TYPE = '/fuel_type/';
export const UPDATE_FUEL_TYPE = '/fuel_type';

// Fuel Type Unit Measurement
export const FUEL_TYPE_UNIT_MEASUREMENT = '/unit_measurement/';
export const GET_FUEL_TYPE_UNIT_MEASUREMENTS = '/unit_measurement/';
export const DELETE_FUEL_TYPE_UNIT_MEASUREMENT = '/unit_measurement';
export const ADD_FUEL_TYPE_UNIT_MEASUREMENT = '/unit_measurement/';
export const UPDATE_FUEL_TYPE_UNIT_MEASUREMENT = '/unit_measurement';

// Power Generation Type
export const POWER_GENERATION_TYPE = '/power_generation_type/';
export const GET_POWER_GENERATION_TYPES = '/power_generation_type/';
export const DELETE_POWER_GENERATION_TYPE = '/power_generation_type';
export const ADD_POWER_GENERATION_TYPE = '/power_generation_type/';
export const UPDATE_POWER_GENERATION_TYPE = '/power_generation_type';

// Power Generation Status
export const POWER_GENERATION_STATUS = '/power_generation_status/';
export const GET_POWER_GENERATION_STATUS = '/power_generation_status/';
export const DELETE_POWER_GENERATION_STATUS = '/power_generation_status';
export const ADD_POWER_GENERATION_STATUS = '/power_generation_status/';
export const UPDATE_POWER_GENERATION_STATUS = '/power_generation_status';

// Power Generation Register Status
export const POWER_GENERATION_REGISTER_STATUS =
	'/power_generation_register_status/';
export const GET_POWER_GENERATION_REGISTER_STATUS =
	'/power_generation_register_status/';
export const POWER_GENERATION_REGISTER_STATUS_CODE =
	'/power_generation_register_status/code';
export const DELETE_POWER_GENERATION_REGISTER_STATUS =
	'/power_generation_register_status';
export const ADD_POWER_GENERATION_REGISTER_STATUS =
	'/power_generation_register_status/';
export const UPDATE_POWER_GENERATION_REGISTER_STATUS =
	'/power_generation_register_status';

// Power Generation Source
export const POWER_GENERATION_SOURCE = '/power_generation_source';
export const GET_POWER_GENERATION_SOURCE = '/power_generation_source/';
export const DELETE_POWER_GENERATION_SOURCE = '/power_generation_source';
export const ADD_POWER_GENERATION_SOURCE = '/power_generation_source/';
export const UPDATE_POWER_GENERATION_SOURCE = '/power_generation_source';

// Power Generation Hour Meter
export const POWER_GENERATION_HOUR_METER = '/power_generation_hour_meter/';
export const GET_POWER_GENERATION_HOUR_METER = '/power_generation_hour_meter/';
export const GET_POWER_GENERATION_HOUR_METER_QUERY =
	'/power_generation_hour_meter/query';
export const POWER_GENERATION_HOUR_METER_SUMMARY_QUERY =
	'/power_generation_hour_meter/summary/query';
export const POWER_GENERATION_HOUR_METER_DAILY_CONSUMPTION_QUERY =
	'/power_generation_hour_meter/daily-consumption/query';
export const DELETE_POWER_GENERATION_HOUR_METER =
	'/power_generation_hour_meter';
export const ADD_POWER_GENERATION_HOUR_METER = '/power_generation_hour_meter/';
export const UPDATE_POWER_GENERATION_HOUR_METER =
	'/power_generation_hour_meter';

// Power Generation Maintenance
export const POWER_GENERATION_MAINTENANCE = '/power_generation_maintenance/';
export const GET_POWER_GENERATION_MAINTENANCE =
	'/power_generation_maintenance/';
export const DELETE_POWER_GENERATION_MAINTENANCE =
	'/power_generation_maintenance';
export const ADD_POWER_GENERATION_MAINTENANCE =
	'/power_generation_maintenance/';
export const UPDATE_POWER_GENERATION_MAINTENANCE =
	'/power_generation_maintenance';

// Fuel Tank
export const FUEL_TANK = '/fuel_tank';
export const GET_FUEL_TANK = '/fuel_tank/';
export const FUEL_TANK_BY_ESTABLISHMENT = '/fuel_tank/establishment';
export const DELETE_FUEL_TANK = '/fuel_tank';
export const ADD_FUEL_TANK = '/fuel_tank/';
export const UPDATE_FUEL_TANK = '/fuel_tank';

// Feeding Silo
export const FEEDING_SILO = '/feeding_silo/';
export const GET_FEEDING_SILO = '/feeding_silo/';
export const DELETE_FEEDING_SILO = '/feeding_silo';
export const ADD_FEEDING_SILO = '/feeding_silo/';
export const UPDATE_FEEDING_SILO = '/feeding_silo';

// Fuel Supply
export const FUEL_SUPPLY = '/fuel_supply/';
export const GET_FUEL_SUPPLY = '/fuel_supply/';
export const GET_FUEL_SUPPLY_QUERY = '/fuel_supply/query';
export const DELETE_FUEL_SUPPLY = '/fuel_supply';
export const ADD_FUEL_SUPPLY = '/fuel_supply/';
export const UPDATE_FUEL_SUPPLY = '/fuel_supply';
export const FUEL_SUPPLY_SUMMARY = '/fuel_supply/summary';
export const FUEL_SUPPLY_SUMMARY_QUERY = '/fuel_supply/summary/query';
export const FUEL_SUPPLY_BY_CENTER_QUERY = '/fuel_supply/supply-by-center/query';
export const FUEL_SUPPLY_SUMMARY_BY_ESTABLISHMENT =
	'/fuel_supply/summary/establishment';
export const FUEL_SUPPLY_SUMMARY_BY_MONTH = '/fuel_supply/summary/month';
export const FUEL_SUPPLY_CONSUMPTION_BY_ESTABLISHMENT =
	'/fuel_supply/dashboard/consumption/establishment';
export const FUEL_SUPPLY_CONSUMPTION_TYPE_SUMMARY =
	'/fuel_supply/dashboard/consumption-type/summary';
export const HOUR_METER_SUMMARY = '/fuel_supply/dashboard/hourmeter/summary';
export const EMISSIONS_SUMMARY = '/fuel_supply/dashboard/emissions/summary';
export const CONSUMPTIONS_SUMMARY =
	'/fuel_supply/dashboard/consumptions/summary';

// Fuel Supply Type
export const FUEL_SUPPLY_TYPE = '/fuel_supply_type/';
export const GET_FUEL_SUPPLY_TYPE = '/fuel_supply_type/';
export const FUEL_SUPPLY_TYPE_CODE = '/fuel_supply_type/code';
export const DELETE_FUEL_SUPPLY_TYPE = '/fuel_supply_type';
export const ADD_FUEL_SUPPLY_TYPE = '/fuel_supply_type/';
export const UPDATE_FUEL_SUPPLY_TYPE = '/fuel_supply_type';

// Maintenance Type
export const MAINTENANCE_TYPE = '/maintenance_type/';
export const GET_MAINTENANCE_TYPE = '/maintenance_type/';
export const DELETE_MAINTENANCE_TYPE = '/maintenance_type';
export const ADD_MAINTENANCE_TYPE = '/maintenance_type/';
export const UPDATE_MAINTENANCE_TYPE = '/maintenance_type';

// Maintenance Type
export const MAINTENANCE_STATUS = '/maintenance_status/';
export const GET_MAINTENANCE_STATUS = '/maintenance_status/';
export const GET_MAINTENANCE_STATUS_CODE = '/maintenance_status/code';
export const DELETE_MAINTENANCE_STATUS = '/maintenance_status';
export const ADD_MAINTENANCE_STATUS = '/maintenance_status/';
export const UPDATE_MAINTENANCE_STATUS = '/maintenance_status';

// Person
export const PERSON = '/person';
export const GET_PERSONS = '/person/';
export const GET_PERSONS_QUERY = '/person/query';
export const DELETE_PERSON = '/person';
export const ADD_PERSON = '/person/';
export const UPDATE_PERSON = '/person';
export const IMPORT_PERSON = '/person/import';

// Person
export const SECTOR = '/sector';
export const GET_SECTORS = '/sector/';
export const DELETE_SECTOR = '/sector';
export const ADD_SECTOR = '/sector/';
export const UPDATE_SECTOR = '/sector';

// Property Type
export const PROPERTY_TYPE = '/property_type';
export const GET_PROPERTY_TYPES = '/property_type/';
export const DELETE_PROPERTY_TYPE = '/property_type';
export const ADD_PROPERTY_TYPE = '/property_type/';
export const UPDATE_PROPERTY_TYPE = '/property_type';

// Establishment Status
export const ESTABLISHMENT_STATUS_LIST = '/establishment_status/';
export const GET_ESTABLISHMENT_STATUS = '/establishment_status/';
export const DELETE_ESTABLISHMENT_STATUS = '/establishment_status';
export const ADD_ESTABLISHMENT_STATUS = '/establishment_status/';
export const UPDATE_ESTABLISHMENT_STATUS = '/establishment_status';

// Consumption Source
export const CONSUMPTION_SOURCE = '/consumption_source';
export const GET_CONSUMPTION_SOURCE = '/consumption_source/';
export const DELETE_CONSUMPTION_SOURCE = '/consumption_source';
export const ADD_CONSUMPTION_SOURCE = '/consumption_source/';
export const UPDATE_CONSUMPTION_SOURCE = '/consumption_source';

// Consumption Source Type
export const CONSUMPTION_SOURCE_TYPE = '/consumption_source_type';
export const GET_CONSUMPTION_SOURCE_TYPE = '/consumption_source_type/';
export const DELETE_CONSUMPTION_SOURCE_TYPE = '/consumption_source_type';
export const ADD_CONSUMPTION_SOURCE_TYPE = '/consumption_source_type/';
export const UPDATE_CONSUMPTION_SOURCE_TYPE = '/consumption_source_type';

// Consumption Type
export const CONSUMPTION_TYPE = '/consumption_type';
export const GET_CONSUMPTION_TYPE = '/consumption_type/';
export const DELETE_CONSUMPTION_TYPE = '/consumption_type';
export const ADD_CONSUMPTION_TYPE = '/consumption_type/';
export const UPDATE_CONSUMPTION_TYPE = '/consumption_type';

// Establishment Query URL for Map
export const GET_ESTABLISHMENTS_QUERY_URL_FOR_MAP = '/establishment/query?populate[0]=commune&populate[1]=region&populate[2]=company&populate[3]=sanitary_vicinity&populate[4]=management&populate[5]=establishment_status&populate[6]=productive_area&populate[7]=establishment_type&populate[8]=establishment_stage&populate[9]=feeding_barges&populate[10]=crop_type&populate[11]=sensor_failure_status&populate[12]=property_type&populate[13]=cost_center&sort[0]=productive_cycle_data.productive_cycle_stage_name%3Aasc&filters[establishment_type.name][$in][0]=Centro%20de%20Agua%20Mar&filters[productive_cycle_data.productive_cycle_stage_name][$in][0]=Engorda&filters[establishment_status.name][$in][0]=Activo&pagination[page]=1&pagination[pageSize]=50'